import styled from "styled-components"
import { Col } from "react-bootstrap"

export const SkillHeaderInfoCol = styled(Col)`
  text-align: left;
  @media only screen and (max-width: 992px){
      text-align:center
  }
`

export const StyledButton = styled.button`
  background: url(/assets/img/button.png);
  background-repeat: no-repeat;
  background-position: center;
  padding: 0.25em 1.5em;
  background-size: 100% 100%;
  border: none;
  font-weight: 700;
  font-size: 1.2em;
  margin: 0.75em 0;
`
